// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.assign-award[data-v-6b45dce7] {\n  display: block;\n  width: 100%;\n  padding: 20px 50px;\n}\n.assign-award__checkbox[data-v-6b45dce7] {\n  margin: 10px 0 20px 0;\n}\n.assign-award__btn[data-v-6b45dce7] {\n  width: auto;\n  margin-left: auto;\n  padding: 0 30px;\n}\n@media (max-width: 768px) {\n.assign-award[data-v-6b45dce7] {\n    padding: 15px;\n}\n.assign-award__checkbox[data-v-6b45dce7] {\n    margin: 10px 0 20px 0;\n}\n}\n", ""]);
// Exports
module.exports = exports;
